/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../objects/context.js';
import ko from 'knockout';
import optionsUtil from '../../objects/optionsUtil.js';
import editorStyleObj from '../../objects/editorStyleObj.js';

class editorStyleSheetModel {

    constructor() {
        // Profile
        this.componentName = "editorStyleSheet";
        this.context = context;
        this.id = "bd02e349-bf72-4f46-ad30-0e2bad2e872c"
        this.visible = ko.observable(true);
        this.styleSheet = ko.observable(" n/a ");

        this.context.eventManager.subscribe(() =>{
           console.log("editorStyleSheet:constructor:");
           this.getData();
        },this, "styleSheetChanged");


    }


    getData() {

        let oUtil = new optionsUtil(this.context);

        let newStyleSheet = "";
        let self = this;

        oUtil.getMasterStyles().then( (result) => {
            //self.context.masterStyleSheet(result);
            ko.utils.arrayForEach(result, (item) => {

                console.log("editorStyleSheet:getData item: %o, formatted style: %s", item);
    
                let tempStyle = new editorStyleObj(item);

                console.log("editorStyleSheet:getData formatted style: %s", tempStyle.getJdmStyle());

                newStyleSheet += tempStyle.getJdmStyle();


            });

        }).then( () => {

            self.styleSheet(newStyleSheet);
            self.styleSheet.valueHasMutated();
            console.log("editorStyleSheet:getData:complete: styleSheet: %o", self.styleSheet());
        });

    }

}

export default { viewModel: editorStyleSheetModel, template: require('!raw-loader!./editorStyleSheet.html') };


// WEBPACK FOOTER //
// ./src/components/editorStyleSheet/editorStyleSheet.js